import { CCQAuthProvider, useCCQAuth } from "@ccq/ts-lib";
import AppRoutes from "@react/AppRoutes";
import { getOidcConfig } from "@react/Helper";
import { IRootScopeService } from "angular";
import { FC } from "react";
import { BrowserRouter } from "react-router-dom";

interface Props {
  $rootScope: IRootScopeService;
}

const LoginCallback: FC<Props> = ({ $rootScope }) => {
  // get the current auth provider
  let currAuthProvider = localStorage.getItem("authProvider");

  // if it doesn't exist, then set it to local
  if (currAuthProvider === null) {
    currAuthProvider = "Local";
    localStorage.setItem("authProvider", "Local");
  }

  return (
    <BrowserRouter>
      <CCQAuthProvider loginCallback={AppRoutes.LoginCallback} getOIDCConfig={getOidcConfig(currAuthProvider)}>
        <LoginCallbackInternal $rootScope={$rootScope} authProvider={currAuthProvider} />
      </CCQAuthProvider>
    </BrowserRouter>
  );
};

interface InternalProps extends Props {
  authProvider: string;
}

const LoginCallbackInternal: FC<InternalProps> = ({ $rootScope, authProvider }) => {
  const { isAuthenticated, idToken, accessToken } = useCCQAuth();

  if (isAuthenticated) {
    switch (authProvider) {
      case "Microsoft":
        $rootScope.$emit("logged-in", accessToken);
        break;
      case "Google":
        $rootScope.$emit("logged-in", idToken);
        break;
      default:
        break;
    }
  }

  return <div>Logging In...</div>;
};

export default LoginCallback;
